var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "mobile-card",
        { attrs: { "title-color": "#fff" } },
        [
          _c("template", { slot: "title" }, [_vm._v(" 订单信息 ")]),
          _c("template", { slot: "content" }, [
            _c("div", { staticClass: "flex-form-info" }, [
              _c("span", [_vm._v("订单号")]),
              _c("span", [_vm._v(_vm._s(_vm.detail.orderNo))])
            ]),
            _c("div", { staticClass: "flex-form-info" }, [
              _c("span", [_vm._v("金额")]),
              _c("span", { staticClass: "money-item" }, [
                _vm._v(_vm._s(_vm._f("formatMoney")(_vm.detail.allMoney)))
              ])
            ])
          ])
        ],
        2
      ),
      _c(
        "mobile-card",
        { attrs: { "title-color": "#fff" } },
        [
          _c("template", { slot: "title" }, [
            _c("span", [_vm._v("支付方式")]),
            _c("span", { staticClass: "countdown-line" }, [
              _c("span", [_vm._v("（请在")]),
              _c("span", { staticClass: "countdown-line-red" }, [
                _vm._v(_vm._s(_vm.countdown))
              ]),
              _c("span", [_vm._v("内完成支付）")])
            ])
          ]),
          _c("template", { slot: "content" }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "flex-form-info" },
                [
                  _c(
                    "span",
                    [
                      _c("van-icon", { attrs: { name: "wechat" } }),
                      _vm._v(" 微信支付 ")
                    ],
                    1
                  ),
                  _c("van-radio", {
                    attrs: { name: "wx", "checked-color": "#005423" },
                    model: {
                      value: _vm.checkType,
                      callback: function($$v) {
                        _vm.checkType = $$v
                      },
                      expression: "checkType"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "pay-part" },
        [
          _c(
            "mobile-button",
            {
              staticClass: "btn-font btn-pay",
              attrs: { borderColor: "#005423", color: "#ffffff" },
              on: { click: _vm.onSubmit }
            },
            [_vm._v(" 支付 ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }